import { z } from 'zod';

export const registrationStepDateAndGenderSchema = z.object({
    dob: z.string().min(1, { message: 'Дата обязательна' }).nullable(),
    gender: z.enum(['male', 'female'], { message: 'Пол обязателен' }),
});

export type RegistrationStepDateAndGenderType = z.infer<typeof registrationStepDateAndGenderSchema>;
